import decode from "jwt-decode";
import { useCallback, useEffect, useState } from "react";
import Cookies from "universal-cookie";

import { config } from "./config.utils";

const cookies = new Cookies();

const getCustomerId = () => {
  const jwt = cookies.get(config.session_cookie);

  if (jwt) {
    const decoded = decode<{ uid: number }>(jwt);

    return decoded?.uid;
  }

  return null;
};

export function useCustomerId() {
  const customerUid = getCustomerId();
  const [customerId, setCustomerId] = useState<number | null>(customerUid);

  const handleCookieChange = useCallback(() => {
    setCustomerId(getCustomerId());
  }, []);

  useEffect(() => {
    cookies.addChangeListener(handleCookieChange);
    return cookies.removeChangeListener(handleCookieChange);
  }, [handleCookieChange]);

  return customerUid || customerId;
}
